module.exports = __webpack_public_path__ + "static/media/townplanner.71b8649c.png";